import { createSlice } from '@reduxjs/toolkit';
import { createAsyncEntity, createFulfilledPrepare, createFulfilledReducer, createInitiatedPrepare, createInitiatedReducer, createRejectedPrepare, createRejectedReducer } from '@oh-auth/common';

function createInitialState() {
  return {
    tokens: createAsyncEntity(),
    public_key: createAsyncEntity()
  };
}

var authSlice = createSlice({
  name: 'auth',
  initialState: createInitialState(),
  reducers: {
    authorize: {
      reducer: () => {},
      prepare: createInitiatedPrepare()
    },
    authorizeFulfilled: {
      reducer: () => {},
      prepare: createFulfilledPrepare()
    },
    authorizeRejected: {
      reducer: () => {},
      prepare: createRejectedPrepare()
    },
    getPublicKey: {
      reducer: createInitiatedReducer('public_key'),
      prepare: createInitiatedPrepare()
    },
    getPublicKeyFulfilled: {
      reducer: createFulfilledReducer('public_key'),
      prepare: createFulfilledPrepare()
    },
    getPublicKeyRejected: {
      reducer: createRejectedReducer('public_key'),
      prepare: createRejectedPrepare()
    },
    getTokens: {
      reducer: createInitiatedReducer('tokens'),
      prepare: createInitiatedPrepare()
    },
    getTokensFulfilled: {
      reducer: createFulfilledReducer('tokens'),
      prepare: createFulfilledPrepare()
    },
    getTokensRejected: {
      reducer: createRejectedReducer('tokens'),
      prepare: createRejectedPrepare()
    },
    revokeToken: {
      reducer: () => {},
      prepare: createInitiatedPrepare()
    },
    revokeTokenFulfilled: {
      reducer: () => {},
      prepare: () => ({
        payload: null
      })
    },
    revokeTokenRejected: {
      reducer: () => {},
      prepare: createRejectedPrepare()
    },
    signUpUser: {
      reducer: createInitiatedReducer('tokens'),
      prepare: createInitiatedPrepare()
    },
    signUpUserFulfilled: {
      reducer: createFulfilledReducer('tokens'),
      prepare: createFulfilledPrepare()
    },
    signUpUserRejected: {
      reducer: createRejectedReducer('tokens'),
      prepare: createRejectedPrepare()
    },
    signInUser: {
      reducer: createInitiatedReducer('tokens'),
      prepare: createInitiatedPrepare()
    },
    signInUserFulfilled: {
      reducer: createFulfilledReducer('tokens'),
      prepare: createFulfilledPrepare()
    },
    signInUserRejected: {
      reducer: createRejectedReducer('tokens'),
      prepare: createRejectedPrepare()
    },
    signOut: {
      reducer: () => createInitialState(),
      prepare: () => ({
        payload: null
      })
    }
  }
});
export var {
  authorize,
  authorizeFulfilled,
  authorizeRejected,
  getPublicKey,
  getPublicKeyFulfilled,
  getPublicKeyRejected,
  getTokens,
  getTokensFulfilled,
  getTokensRejected,
  revokeToken,
  revokeTokenFulfilled,
  revokeTokenRejected,
  signUpUser,
  signUpUserFulfilled,
  signUpUserRejected,
  signInUser,
  signInUserFulfilled,
  signInUserRejected,
  signOut
} = authSlice.actions;
export var authReducer = authSlice.reducer;